import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.dashboardOverview || initialState;

export const selectDashboardOverview = createSelector(
  [selectDomain],
  state => state,
);
